import { render, staticRenderFns } from "./XomeRegisterInstructions.vue?vue&type=template&id=2d7736ac&"
import script from "./XomeRegisterInstructions.vue?vue&type=script&lang=js&"
export * from "./XomeRegisterInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports